import {
    Component,
    ComponentInterface,
    Event,
    EventEmitter,
    h,
    Host,
    Method,
    Prop,
    Watch,
} from "@stencil/core";

@Component({
    tag: "uic-tab",
    styleUrl: "tab.scss",
})
export class Tab implements ComponentInterface {
    /**
     * Indicates this tab requesting to be selected.
     */
    @Event({ eventName: "uicTabSelect" })
    selectRequest: EventEmitter<void>;

    /**
     * The text shown inside the tab.
     */
    @Prop({ reflect: true }) label?: string;

    /**
     * If set to `true`, indicates that the tab is the selected one inside a tab-list.
     */
    @Prop({ reflect: true }) selected = false;

    /**
     * The value used to uniquely identify the tab inside the tab-list.
     */
    @Prop({ reflect: true }) value = "";

    /**
     * If set to `true`, the tabs orientation is considered to be vertical.
     */
    @Prop({ reflect: true }) vertical = false;

    /**
     * If set to `true`, the user cannot interact with this tab.
     */
    @Prop() disabled = false;

    /**
     * The name of the icon.
     */
    @Prop() icon?: string;

    @Watch("selected")
    onSelectedChange() {
        if (this.selected) {
            this.select();
        }
    }

    render() {
        return (
            <Host
                role="tab"
                aria-disabled={this.disabled}
                aria-selected={this.selected}
                tabindex={this.disabled || !this.selected ? "-1" : "0"}
                onclick={() => this.select()}
            >
                <slot name="icon">
                    {this.icon && <uic-icon name={this.icon}></uic-icon>}
                </slot>
                <span class="uic-tab__label">
                    <slot>{this.label}</slot>
                </span>
            </Host>
        );
    }

    /**
     * Requests current tab to become selected one in its containing uic-tab-list.
     */
    @Method()
    async select() {
        if (!this.disabled) {
            this.selectRequest.emit();
        }
    }
}
